// extracted by mini-css-extract-plugin
module.exports = {"root":"Signup_root___XGMJ"};